import { Outlet } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAppConfig } from '@shared/app/app-config';
import { useAuthStore } from '@shared/store/auth.store';
import { RouteSplashScreen } from '@shared/router/RouteSplashScreen';
import { NoApplicationAccessPage } from '@shared/router/NoApplicationAccessPage';

/**
 * Second gate, inside ProtectedRoute: may this account open THIS application?
 *
 * Application access is data on the account (`/auth/me` → `applications`),
 * not a role and not a permission, and it has no Owner bypass — exactly like
 * the backend's ApplicationAccessGuard, which refuses every request of an
 * application the account does not hold. This gate only saves the user a
 * screen of 403s; the backend remains the authority.
 */
export function ApplicationGuard({ children }: { children?: ReactNode }) {
  const { application } = useAppConfig();
  const loaded = useAuthStore((state) => state.authorization.loaded);
  const allowed = useAuthStore((state) => state.authorization.applications.includes(application));

  if (!loaded) return <RouteSplashScreen />;
  if (!allowed) return <NoApplicationAccessPage />;
  return <>{children ?? <Outlet />}</>;
}
